let lastAppOpenedAt = Date.now();

export function markAppOpened() {
  lastAppOpenedAt = Date.now();
}

export function wasAppJustOpened(windowMs: number) {
  return Date.now() - lastAppOpenedAt < windowMs;
}



// WEBPACK FOOTER //
// ./src/helpers/appLifecycle.ts